import { z } from 'zod'

/**
 * A configuracao do cliente do mundo, fixada no build (`VITE_*`). docs/21, ADR 0042.
 *
 *   VITE_API_URL    -> o `api` (refresh, acesso, entrada no mundo)
 *   VITE_WEB2_URL   -> o `web2` (login, "Voltar ao jogo", duelo)
 *   VITE_WORLD_URL  -> o `world-server` (a partir de modo_historia/04)
 *
 * Validada na partida: faltar uma URL e defeito de publicacao, e ele aparece aqui, e nao como um `fetch`
 * para `undefined/auth/refresh`.
 */

const url = z.string().url()

export const configSchema = z.object({
  apiUrl: url,
  web2Url: url,
  worldUrl: url.optional(),
})
export type AppConfig = z.infer<typeof configSchema>

/** Sem barra final: os caminhos sao concatenados com `/`. */
const trimmed = (value: string | undefined): string | undefined =>
  value === undefined || value === '' ? undefined : value.replace(/\/+$/, '')

export function readConfig(env: Record<string, string | undefined>): AppConfig {
  const worldUrl = trimmed(env['VITE_WORLD_URL'])
  return configSchema.parse({
    apiUrl: trimmed(env['VITE_API_URL']),
    web2Url: trimmed(env['VITE_WEB2_URL']),
    ...(worldUrl === undefined ? {} : { worldUrl }),
  })
}
